import { BaseValidator } from './baseValidator';
import ValidationErrors from '../fields/validationErrors';

export class CompanyNameFieldValidator extends BaseValidator {
    public EUCompanyLengthRule(value: string) {
        const MAX_LENGTH = 255;

        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                rule: 'EUCompanyLengthRule',
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
            };
        }

        return null;
    }

    public JPCompanyLengthRule(value: string) {
        const MAX_LENGTH = 85;

        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                rule: 'JPCompanyLengthRule',
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
            };
        }

        return null;
    }
}
